<template>
    <v-badge
        :offsetX="3"
        :offsetY="3"
        :dot="true"
        :class="badgeClasses"
        :modelValue="props.badge"
    >
        <v-btn
            v-link="[$router, props.to]"
            class="deepi-button-icon"
            to=""
            :flat="true"
            :icon="true"
            :class="classes"
            :loading="props.loading"
            :readonly="props.disabled"
            @click.stop="emit('click', $event)"
        >
            <v-icon
                :size="iconSize"
                :icon="props.icon"
            />
        </v-btn>
    </v-badge>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type RouteLocationRaw } from 'vue-router';

export interface DeepiButtonIconProps {
    icon?: string;
    to?: RouteLocationRaw | (() => RouteLocationRaw);
    size?: 'small' | 'medium' | 'large';
    variant?: 'light' | 'dark';
    color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error';
    badge?: boolean;
    loading?: boolean;
    disabled?: boolean;
};

const props = withDefaults(defineProps<DeepiButtonIconProps>(), {
    size: 'large',
    variant: 'light',
    color: 'secondary'
});

const emit = defineEmits(['click']);

const badgeClasses = computed((): string[] => {
    const classes: string[] = [];
    if (props.disabled) {
        classes.push('disabled');
    }
    return classes;
});

const iconSize = computed((): number => {
    return props.size === 'small' ? 12 : 18;
});

const classes = computed((): string[] => {
    return [props.size, props.variant, props.color];
});
</script>

<style scoped lang="scss">
@use 'DeepiButtonIcon.scss';
</style>